import * as React from "react";

function SvgIcons8Select(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M16 4C9.383 4 4 9.383 4 16s5.383 12 12 12 12-5.383 12-12S22.617 4 16 4zm0 2c5.535 0 10 4.465 10 10s-4.465 10-10 10S6 21.535 6 16 10.465 6 16 6zm0 7a3 3 0 10.002 6.002A3 3 0 0016 13z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Select);
